import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.main');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const wiz: any;

@Component({
    selector: 'wiz-page-main',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.main/view.scss */
/* src/app/page.main/view.scss: no such file or directory */`],
})
export class PageMainComponent implements OnInit {
    public searchText: string = '';

    // 통계
    public totalDocs: number = 0;
    public totalPages: number = 0;
    public totalCategories: number = 0;

    // 최근 문서
    public recentDocs: any[] = [];

    // 주요 기능 카드
    public features = [
        {
            icon: 'fa-solid fa-search',
            title: '하이브리드 검색',
            desc: '키워드와 의미 기반 벡터 검색을 결합하여 정확한 검색 결과를 제공합니다.',
        },
        {
            icon: 'fa-solid fa-wand-magic-sparkles',
            title: 'AI 분석 & 요약',
            desc: '보고서의 핵심 내용을 자동 분석하고, 이해하기 쉬운 요약을 생성합니다.',
        },
        {
            icon: 'fa-solid fa-comments',
            title: '문서 Q&A',
            desc: '보고서에 대해 자유롭게 질문하면 AI가 근거 기반으로 답변합니다.',
        },
        {
            icon: 'fa-solid fa-diagram-project',
            title: '지식그래프',
            desc: '유적·유물·시대 간 관계를 네트워크 그래프로 시각화합니다.',
        },
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadStats();
        await this.loadRecentDocs();
        await this.service.render();
    }

    private async loadStats() {
        try {
            const { code, data } = await wiz.call('stats');
            if (code === 200) {
                this.totalDocs = data.total_docs || 0;
                this.totalPages = data.total_pages || 0;
                this.totalCategories = data.total_categories || 0;
            }
        } catch (e) {
            // ignore
        }
    }

    private async loadRecentDocs() {
        try {
            const { code, data } = await wiz.call('recent');
            if (code === 200) {
                this.recentDocs = data || [];
            }
        } catch (e) {
            // ignore
        }
    }

    public onSearch() {
        if (!this.searchText.trim()) return;
        this.service.href(`/search?q=${encodeURIComponent(this.searchText)}`);
    }

    public onSearchKeydown(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            this.onSearch();
        }
    }

    public openDocument(doc: any) {
        this.service.href(`/document/${doc.id}`);
    }
}

export default PageMainComponent;